import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Dropdown, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import BasicInformationCard from "../BasicInformationCard/BasicInformationCard.jsx";
import ExperienceCard from "../ExperienceCard/ExperienceCard.jsx";
import EducationCard from "../EducationCard/EducationCard.jsx";
import AddExperienceModal from "../AddExperienceModal/AddExperienceModal.jsx";
import EditExperienceModal from "../EditExperienceModal/EditExperienceModal.jsx";
import ProfileExperienceModal from "../ProfileExperienceModal/ProfileExperienceModal.jsx";
import AddEducationModal from "../AddEducationModal/AddEducationModal.jsx";
import EditEducationModal from "../EditEducationModal/EditEducationModal.jsx";
import CoursesCard from "../CoursesCard/CoursesCard.jsx";
import DeactivateUserModal from "../DeactivateUserModal/DeactivateUserModal.jsx";
import {
  addExperienceAPI,
  updateExperienceAPI,
  deleteExperienceAPI,
  addEducationAPI,
  updateEducationAPI,
  deleteEducationAPI,
  getStudentByIdAPI,
} from "../../redux/features/adminSlice";
import { useSearchParams } from "react-router-dom";
import ProfileEducationModal from "../ProfileEducationModal/ProfileEducationModal.jsx";
import ConfirmationModal from "../deleteConfimationModal/deleteConfimationModal";

const InstructorDetailsComponent = ({ userId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const [searchParams] = useSearchParams();

  let pathName = window.location.pathname;
  let pathFiltered = pathName.split("/").pop();

  const { selectedStudent, loading, error } = useSelector(
    (state) => state.admin
  );
  const {
    profile,
    experiences = [],
    educations = [],
    courses = [],
  } = selectedStudent || {};

  const [showProfileExperienceModal, setShowProfileExperienceModal] =
    useState(false);
  const [profileExperienceTitleModal, setProfileExperienceTitleModal] =
    useState("");
  const [showProfileEducationModal, setShowProfileEducationModal] =
    useState(false);
  const [profileEducationTitleModal, setProfileEducationTitleModal] =
    useState("");
  const [experienceDataGetFromItem, setExperienceDataGetFromItem] = useState(
    []
  );
  const [showAddExperienceModal, setShowAddExperienceModal] = useState(false);
  const [showEditExperienceModal, setShowEditExperienceModal] = useState(false);
  const [showAddEducationModal, setShowAddEducationModal] = useState(false);
  const [showEditEducationModal, setShowEditEducationModal] = useState(false);
  const [selectedExperience, setSelectedExperience] = useState(null);
  const [selectedEducation, setSelectedEducation] = useState(null);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [deleteItemType, setDeleteItemType] = useState("");
  const [isDeleting, setIsDeleting] = useState(false); // Delete loading state

  const handleAddExperience = async (newExperience) => {
    if (!auth?.token) {
      toast.error("Please log in to add experience.", {
        position: "top-center",
      });
      return;
    }
    try {
      await dispatch(
        addExperienceAPI({
          token: auth.token,
          payload: { ...newExperience, user_id: userId },
        })
      ).unwrap();
      toast.success("Experience added successfully.", {
        position: "top-center",
      });
      setShowAddExperienceModal(false);
      refreshDataHandler();
    } catch (error) {
      const errorMessage =
        typeof error === "string"
          ? error
          : error?.message || "Failed to add experience.";
      toast.error(errorMessage, { position: "top-center" });
    }
  };

  const handleEditExperience = async (updatedExperience) => {
    if (!auth?.token) {
      toast.error("Please log in to edit experience.", {
        position: "top-center",
      });
      return;
    }
    try {
      await dispatch(
        updateExperienceAPI({ token: auth.token, payload: updatedExperience })
      ).unwrap();
      toast.success("Experience updated successfully.", {
        position: "top-center",
      });
      setShowEditExperienceModal(false);
      setSelectedExperience(null);
      refreshDataHandler();
    } catch (error) {
      const errorMessage =
        typeof error === "string"
          ? error
          : error?.message || "Failed to update experience.";
      toast.error(errorMessage, { position: "top-center" });
    }
  };

  const refreshDataHandler = () => {
    dispatch(getStudentByIdAPI({ token: auth.token, userId }));
  };

  const handleDeleteExperience = async (experienceId) => {
    if (!auth?.token) {
      toast.error("Please log in to delete experience.", {
        position: "top-center",
      });
      return;
    }
    try {
      await dispatch(
        deleteExperienceAPI({ token: auth.token, experienceId, userId })
      ).unwrap();
      toast.success("Experience deleted successfully.", {
        position: "top-center",
      });
      refreshDataHandler();
    } catch (error) {
      const errorMessage =
        typeof error === "string"
          ? error
          : error?.message || "Failed to delete experience.";
      toast.error(errorMessage, { position: "top-center" });
      throw error; // Re-throw error to handle in confirmDelete
    }
  };

  const handleAddEducation = async (newEducation) => {
    if (!auth?.token) {
      toast.error("Please log in to add education.", {
        position: "top-center",
      });
      return;
    }
    try {
      const res = await dispatch(
        addEducationAPI({
          token: auth.token,
          payload: { ...newEducation, user_id: userId },
        })
      ).unwrap();
      toast.success("Education added successfully.", {
        position: "top-center",
      });
      setShowAddEducationModal(false);
      refreshDataHandler();
    } catch (error) {
      const errorMessage =
        typeof error === "string"
          ? error
          : error?.message || "Failed to add education.";
      toast.error(errorMessage, { position: "top-center" });
    }
  };

  const handleEditEducation = async (updatedEducation) => {
    if (!auth?.token) {
      toast.error("Please log in to edit education.", {
        position: "top-center",
      });
      return;
    }
    try {
      await dispatch(
        updateEducationAPI({ token: auth.token, payload: updatedEducation })
      ).unwrap();
      toast.success("Education updated successfully.", {
        position: "top-center",
      });
      setShowEditEducationModal(false);
      setSelectedEducation(null);
      refreshDataHandler();
    } catch (error) {
      const errorMessage =
        typeof error === "string"
          ? error
          : error?.message || "Failed to update education.";
      toast.error(errorMessage, { position: "top-center" });
    }
  };

  const handleDeleteEducation = async (educationId) => {
    if (!auth?.token) {
      toast.error("Please log in to delete education.", {
        position: "top-center",
      });
      return;
    }
    try {
      await dispatch(
        deleteEducationAPI({ token: auth.token, educationId, userId, role: auth.role })
      ).unwrap();
      toast.success("Education deleted successfully.", {
        position: "top-center",
      });
      refreshDataHandler();
    } catch (error) {
      const errorMessage =
        typeof error === "string"
          ? error
          : error?.message || "Failed to delete education.";
      toast.error(errorMessage, { position: "top-center" });
      throw error; // Re-throw error to handle in confirmDelete
    }
  };

  const openEditExperienceModal = (experience) => {
    setSelectedExperience(experience);
    setShowEditExperienceModal(true);
  };

  const openEditEducationModal = (education) => {
    setSelectedEducation(education);
    setShowEditEducationModal(true);
  };

  // Handler to open confirmation modal for experience deletion
  const confirmDeleteExperience = (experience) => {
    setDeleteItem({ id: experience.id, name: experience.title || experience.company_name || "experience" });
    setDeleteItemType("experience");
    setShowConfirmModal(true);
  };

  // Handler to open confirmation modal for education deletion
  const confirmDeleteEducation = (education) => {
    setDeleteItem({ id: education.id, name: education.degree || education.title || "education" });
    setDeleteItemType("education");
    setShowConfirmModal(true);
  };

  // Handler for confirming deletion
  const handleConfirmDelete = async () => {
    setIsDeleting(true); // Start delete loading
    try {
      if (deleteItemType === "experience") {
        await handleDeleteExperience(deleteItem.id);
      } else if (deleteItemType === "education") {
        await handleDeleteEducation(deleteItem.id);
      }
      setShowConfirmModal(false);
      setDeleteItem(null);
      setDeleteItemType("");
    } catch (error) {
      // Error already handled in handleDeleteExperience/Education
    } finally {
      setIsDeleting(false); // Stop delete loading
    }
  };

  return (
    <>
      <div className="card-default-style p-10 p-sm-20 p-md-30 p-lg-40 mb-20">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-17">
          <h2 className="ah-heading-04 fw-bold black-800">Basic Information</h2>
          <Dropdown className="custom-dropdown profile-dropdown">
            <Dropdown.Toggle variant="light" className="icon-btn py-8 px-12" disabled={isDeleting}>
              <svg
                width="25"
                height="26"
                viewBox="0 0 25 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5 8.3125C13.3629 8.3125 14.0625 7.61295 14.0625 6.75C14.0625 5.88706 13.3629 5.1875 12.5 5.1875C11.6371 5.1875 10.9375 5.88706 10.9375 6.75C10.9375 7.61295 11.6371 8.3125 12.5 8.3125Z"
                  fill="#F05203"
                />
                <path
                  d="M12.5 14.5625C13.3629 14.5625 14.0625 13.8629 14.0625 13C14.0625 12.1371 13.3629 11.4375 12.5 11.4375C11.6371 11.4375 10.9375 12.1371 10.9375 13C10.9375 13.8629 11.6371 14.5625 12.5 14.5625Z"
                  fill="#F05203"
                />
                <path
                  d="M12.5 20.8125C13.3629 20.8125 14.0625 20.1129 14.0625 19.25C14.0625 18.3871 13.3629 17.6875 12.5 17.6875C11.6371 17.6875 10.9375 18.3871 10.9375 19.25C10.9375 20.1129 11.6371 20.8125 12.5 20.8125Z"
                  fill="#F05203"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu align="end">
              {auth.role === "Instructor" && (window.location.pathname === "/instructor-student" || window.location.pathname === "/student-details") ? (
                ""
              ) : (
                <Dropdown.Item
                  as={Link}
                  to={`/edit-profile?id=${userId}&path=${pathFiltered}`}
                >
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.5 1.49999H3.25C2.2835 1.49999 1.5 2.28349 1.5 3.24999V13.75C1.5 14.7165 2.2835 15.5 3.25 15.5H13.75C14.7165 15.5 15.5 14.7165 15.5 13.75V8.49999M14.1124 5.36242L15.0625 4.41238C15.7459 3.72896 15.7459 2.62093 15.0625 1.93752C14.379 1.25409 13.271 1.2541 12.5876 1.93752L11.6376 2.88754M14.1124 5.36242L8.83071 10.6442C8.5864 10.8885 8.27525 11.0551 7.93646 11.1228L5.36245 11.6376L5.87725 9.06359C5.94501 8.72481 6.11153 8.41366 6.35582 8.16937L11.6376 2.88754M14.1124 5.36242L11.6376 2.88754"
                      stroke="#F05203"
                      strokeWidth="1.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Edit
                </Dropdown.Item>
              )}
              {/* <Dropdown.Item as={Link} to={`/share-profile/${userId}`}>
                <svg
                  width="18"
                  height="20"
                  viewBox="0 0 18 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 20C14.1667 20 13.4583 19.7083 12.875 19.125C12.2917 18.5417 12 17.8333 12 17C12 16.9 12.025 16.6667 12.075 16.3L5.05 12.2C4.78333 12.45 4.475 12.646 4.125 12.788C3.775 12.93 3.4 13.0007 3 13C2.16667 13 1.45833 12.7083 0.875 12.125C0.291667 11.5417 0 10.8333 0 10C0 9.16667 0.291667 8.45833 0.875 7.875C1.45833 7.29167 2.16667 7 3 7C3.4 7 3.775 7.071 4.125 7.213C4.475 7.355 4.78333 7.55067 5.05 7.8L12.075 3.7C12.0417 3.58333 12.021 3.471 12.013 3.363C12.005 3.255 12.0007 3.134 12 3C12 2.16667 12.2917 1.45833 12.875 0.875C13.4583 0.291667 14.1667 0 15 0C15.8333 0 16.5417 0.291667 17.125 0.875C17.7083 1.45833 18 2.16667 18 3C18 3.83333 17.7083 4.54167 17.125 5.125C16.5417 5.70833 15.8333 6 15 6C14.6 6 14.225 5.929 13.875 5.787C13.525 5.645 13.2167 5.44933 12.95 5.2L5.925 9.3C5.95833 9.41667 5.97933 9.52933 5.988 9.638C5.99667 9.74667 6.00067 9.86733 6 10C5.99933 10.1327 5.99533 10.2537 5.988 10.363C5.98067 10.4723 5.95967 10.5847 5.925 10.7L12.95 14.8C13.2167 14.55 13.525 14.3543 13.875 14.213C14.225 14.0717 14.6 14.0007 15 14C15.8333 14 16.5417 14.2917 17.125 14.875C17.7083 15.4583 18 16.1667 18 17C18 17.8333 17.7083 18.5417 17.125 19.125C16.5417 19.7083 15.8333 20 15 20Z"
                    fill="#F05203"
                  />
                </svg>
                Share Profile
              </Dropdown.Item> */}
              {window.location.pathname === "/profile" ? null : (
                <Dropdown.Item
                  onClick={() => setShowDeactivateModal(true)}
                  disabled={isDeleting || profile?.status === "deactivated"}
                >
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.5 17.7031C14.0305 17.7031 17.7031 14.0305 17.7031 9.5C17.7031 4.96954 14.0305 1.29688 9.5 1.29688C4.96954 1.29688 1.29688 4.96954 1.29688 9.5C1.29688 14.0305 4.96954 17.7031 9.5 17.7031Z"
                      stroke="#F05203"
                      strokeWidth="1.96875"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4.57812 14.4219L15.0781 3.92188"
                      stroke="#F05203"
                      strokeWidth="1.96875"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Deactivate
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        {profile ? (
          <BasicInformationCard profile={profile} />
        ) : (
          <div className="alert alert-info">No profile data available.</div>
        )}
      </div>

      <div className="card-default-style p-10 p-sm-20 p-md-30 p-lg-40 mb-10 mb-sm-20 mb-md-35 mb-lg-50">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-24">
          <h2 className="ah-heading-04 fw-bold black-800">Experiences</h2>
          {auth.role === "Instructor" && (window.location.pathname === "/instructor-student" || window.location.pathname === "/student-details") ? (
            ""
          ) : (
            <span
              className="text-base fw-normal d-flex align-content-center"
              type="button"
              onClick={() => {
                setShowProfileExperienceModal(true);
                setProfileExperienceTitleModal("Add Experience");
              }}
              disabled={isDeleting}
            >
              <svg
                className="me-12"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.75"
                  y="0.75"
                  width="22.5"
                  height="22.5"
                  rx="5.25"
                  fill="#82BD00"
                  fillOpacity="0.11"
                />
                <rect
                  x="0.75"
                  y="0.75"
                  width="22.5"
                  height="22.5"
                  rx="5.25"
                  stroke="#82BD00"
                  strokeWidth="1.5"
                />
                <path
                  d="M6 12L18 12"
                  stroke="#82BD00"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6L12 18"
                  stroke="#82BD00"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Add more Experience
            </span>
          )}
        </div>
        {experiences.length > 0 ? (
          experiences.map((experience) => (
            <ExperienceCard
              key={experience.id}
              experience={experience}
              setShowEditExperienceModal={() =>
                openEditExperienceModal(experience)
              }
              setExperienceDataGetFromItem={setExperienceDataGetFromItem}
              handleDeleteExperience={() =>
                confirmDeleteExperience(experience)
              }
              setProfileExperienceTitleModal={setProfileExperienceTitleModal}
              setShowProfileExperienceModal={setShowProfileExperienceModal}
            />
          ))
        ) : (
          <div className="alert alert-info">No experiences available.</div>
        )}
      </div>

      <div className="card-default-style p-10 p-sm-20 p-md-30 p-lg-40 mb-10 mb-sm-20 mb-md-35 mb-lg-50">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-24">
          <h2 className="ad-heading-05 fw-bold black-800">Education</h2>
          {auth.role === "Instructor" && (window.location.pathname === "/instructor-student" || window.location.pathname === "/student-details") ? (
            ""
          ) : (
            <span
              className="border-0 p-0 text-base fw-normal d-flex align-content-center"
              type="button"
              onClick={() => {
                setShowProfileEducationModal(true);
                setProfileEducationTitleModal("Add Education");
              }}
              disabled={isDeleting}
            >
              <svg
                className="me-12"
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="1.52783"
                  y="1.28052"
                  width="22.5"
                  height="22.5"
                  rx="5.25"
                  fill="#F05203"
                  fillOpacity="0.04"
                />
                <rect
                  x="1.52783"
                  y="1.28052"
                  width="22.5"
                  height="22.5"
                  rx="5.25"
                  stroke="#F05203"
                  strokeWidth="1.5"
                />
                <path
                  d="M6.77783 12.5305L18.7778 12.5305"
                  stroke="#F05203"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12.7778 6.53052L12.7778 18.5305"
                  stroke="#F05203"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Add more Education
            </span>
          )}
        </div>
        {educations.length > 0 ? (
          educations.map((education) => (
            <EducationCard
              key={education.id}
              education={education}
              setShowEditEducationModal={() =>
                openEditEducationModal(education)
              }
              handleDeleteEducation={() =>
                confirmDeleteEducation(education)
              }
              setShowProfileEducationModal={setShowProfileEducationModal}
              setProfileEducationTitleModal={setProfileEducationTitleModal}
            />
          ))
        ) : (
          <div className="alert alert-info">No educations available.</div>
        )}
      </div>

      {/* Existing modals */}
      {showProfileExperienceModal && (
        <ProfileExperienceModal
          title={profileExperienceTitleModal}
          show={showProfileExperienceModal}
          handleClose={() => {
            setShowProfileExperienceModal(false);
            setSelectedExperience(null);
          }}
          editExperience={handleEditExperience}
          experienceDataGetFromItem={experienceDataGetFromItem}
          experience={selectedExperience}
          refreshDataHandler={refreshDataHandler}
        />
      )}
      {showProfileEducationModal && (
        <ProfileEducationModal
          title={profileEducationTitleModal}
          show={showProfileEducationModal}
          handleClose={() => {
            setShowProfileEducationModal(false);
            setSelectedEducation(null);
          }}
          education={selectedEducation}
          refreshDataHandler={refreshDataHandler}
        />
      )}
      {showDeactivateModal && (
        <DeactivateUserModal
          show={showDeactivateModal}
          onHide={() => setShowDeactivateModal(false)}
          userId={userId}
          fullName={profile?.full_name}
          refreshDataHandler={refreshDataHandler}
        />
      )}
      {/* External Confirmation Modal */}
      {showConfirmModal && (
        <ConfirmationModal
          isOpen={showConfirmModal}
          onClose={() => {
            setShowConfirmModal(false);
            setDeleteItem(null);
            setDeleteItemType("");
          }}
          onConfirm={handleConfirmDelete}
          deleteType={deleteItemType}
          itemId={deleteItem?.id}
        />
      )}
    </>
  );
};

export default InstructorDetailsComponent;
